(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-collection-breaks"] && !Shopify.designMode) return;
  try {
    
  class ShoppableCollectionBreaks extends HTMLElement {
    connectedCallback() {
      this.breaks = Array.from(this.querySelectorAll('[data-shop-look-break]'));
      if (!this.breaks.length) return;
      this.applying = false;
      this.findRootAndObserve(0);
    }

    findLiveGrid() {
      return this.findLiveGridIn(this.observedRoot || document);
    }

    findLiveGridIn(root) {
      return root.querySelector('.usf-results') ||
             root.querySelector('.collection-grid__wrapper .grid.grid--uniform') ||
             root.querySelector('.product-grid, main .grid.grid--uniform');
    }

    findRootAndObserve(attempt) {
      // Observe a stable ancestor that persists even when USF swaps its
      // skeleton grid out for a freshly created results element, rather
      // than observing (or caching a reference to) the grid node itself.
      var root = document.getElementById('CollectionAjaxContent') ||
                 document.querySelector('.collection-content') ||
                 document.querySelector('main');

      if (!root || !this.findLiveGridIn(root)) {
        if (attempt < 40) {
          setTimeout(() => this.findRootAndObserve(attempt + 1), 250);
        }
        return;
      }

      this.observedRoot = root;
      this.apply();
      // Safety net: on some loads, USF's initial swap from skeleton to real
      // results can race ahead of both the "sr_updated" hook and the
      // MutationObserver attachment below. A couple of cheap follow-up
      // checks shortly after guarantee the first paint is still correct.
      setTimeout(() => this.apply(), 600);
      setTimeout(() => this.apply(), 1800);

      var self = this;
      var debounceTimer;
      this.observer = new MutationObserver(function (mutations) {
        if (self.applying) return;
        var relevant = mutations.some(function (m) {
          return Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes)).some(function (n) {
            return !(n.hasAttribute && n.hasAttribute('data-shop-look-injected'));
          });
        });
        if (!relevant) return;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { self.apply(); }, 80);
      });
      this.observer.observe(root, { childList: true, subtree: true });

      if (window.usf && window.usf.event && typeof window.usf.event.add === 'function') {
        window.usf.event.add('sr_updated', function () { self.apply(); });
      } else {
        var usfTries = 0;
        var usfPoll = setInterval(function () {
          usfTries++;
          if (window.usf && window.usf.event && typeof window.usf.event.add === 'function') {
            window.usf.event.add('sr_updated', function () { self.apply(); });
            clearInterval(usfPoll);
          } else if (usfTries > 40) {
            clearInterval(usfPoll);
          }
        }, 250);
      }
    }

    // Hero pins reveal their product card via a plain class toggle, scoped
    // entirely to this one cloned root -- no native Popover API, no global
    // ids needed. (An earlier version used the browser's Popover API, but it
    // didn't reliably respond to clicks inside Shopify's theme editor
    // preview iframe. This mirrors the Image Hotspots side panel's proven
    // is-active toggle instead.)
    wireHeroPins(root) {
      var buttons = root.querySelectorAll('[data-hero-pin-toggle]');
      Array.prototype.forEach.call(buttons, function (btn) {
        btn.addEventListener('click', function (event) {
          event.stopPropagation();
          var key = btn.getAttribute('data-hero-pin-toggle');
          var card = root.querySelector('[data-hero-pin-card="' + key + '"]');
          if (!card) return;
          var wasOpen = card.classList.contains('is-open');
          Array.prototype.forEach.call(root.querySelectorAll('[data-hero-pin-card].is-open'), function (c) {
            c.classList.remove('is-open');
          });
          if (!wasOpen) card.classList.add('is-open');
        });
      });
      if (buttons.length) {
        document.addEventListener('click', function () {
          Array.prototype.forEach.call(root.querySelectorAll('[data-hero-pin-card].is-open'), function (c) {
            c.classList.remove('is-open');
          });
        });
      }
    }

    // The hidden template carries {{ block.shopify_attributes }} so the real
    // block can be selected/edited normally in the theme editor sidebar. The
    // clone we inject into the grid is a visual duplicate, not that real
    // block -- but the editor doesn't know that, and reacts to those same
    // attributes by jumping to and highlighting the section wherever it
    // actually lives in the template (here, at the end, since that's this
    // section's real position). Stripping them from the clone stops that:
    // clicks on the injected copy then only trigger our own handlers.
    stripEditorAttributes(root) {
      var all = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
      all.forEach(function (el) {
        Array.prototype.slice.call(el.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify-') === 0) {
            el.removeAttribute(attr.name);
          }
        });
      });
    }

    apply() {
      var grid = this.findLiveGrid();
      if (!grid) return;

      var items = Array.prototype.filter.call(grid.children, function (el) {
        return el.hasAttribute('data-product-id') || el.hasAttribute('data-usf-pid');
      });

      // Skip the rebuild entirely when the actual product list hasn't
      // changed. Without this, any incidental DOM churn nearby (lazy-loaded
      // images swapping in, animation classes toggling, third-party widgets
      // mutating their own markup) re-triggers a full teardown/rebuild of
      // every break -- which would also silently close an open hero card or
      // reset the active hotspot pin the instant a customer opens one.
      var signature = items.length + '|' + items.map(function (el) {
        return el.dataset.productId || el.dataset.usfPid || '';
      }).join(',');
      if (signature === this.lastSignature) return;
      this.lastSignature = signature;

      this.applying = true;

      var existing = grid.querySelectorAll('[data-shop-look-injected]');
      for (var i = 0; i < existing.length; i++) existing[i].remove();

      var breaks = this.breaks.slice().sort(function (a, b) {
        return Number(a.dataset.insertAfter) - Number(b.dataset.insertAfter);
      });

      var self = this;
      breaks.forEach(function (breakEl) {
        var pos = Number(breakEl.dataset.insertAfter);
        if (!pos || pos > items.length) return;
        var clone = breakEl.cloneNode(true);
        clone.removeAttribute('hidden');
        clone.setAttribute('data-shop-look-injected', '');
        self.stripEditorAttributes(clone);
        self.wireHeroPins(clone);
        items[pos - 1].after(clone);
      });

      requestAnimationFrame(() => { this.applying = false; });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('shoppable-collection-breaks')) {
    customElements.define('shoppable-collection-breaks', ShoppableCollectionBreaks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
